import { Link } from "react-router-dom";
import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Breadcrumb from "@/components/feature/Breadcrumb";
import PricingSection from "@/components/feature/PricingSection";
import MobileCTABar from "@/components/feature/MobileCTABar";
import HeroSection from "./components/HeroSection";
import TeamSection from "./components/TeamSection";
import WhyChooseSection from "./components/WhyChooseSection";
import ServicesSection from "./components/ServicesSection";
import TrustBannerSection from "@/components/feature/TrustBannerSection";
import TrustSection from "./components/TrustSection";
import AveriasFrecuentesSection from "@/components/feature/AveriasFrecuentesSection";
import FAQSection from "@/components/feature/FAQSection";
import ComoTrabajamosSection from "@/components/feature/ComoTrabajamosSection";
import NeighborhoodsSection from "./components/NeighborhoodsSection";
import VideoDiagnosisSection from "./components/VideoDiagnosisSection";
import TestimonialsSection from "./components/TestimonialsSection";
import QuoteFormSection from "./components/QuoteFormSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="Persianas Málaga | Reparación de Persianas en Málaga Capital"
        description="Reparación de persianas, mosquiteras y motorización en Málaga capital y 16 barrios. Presupuesto gratis, respuesta 24-48h, 2 años de garantía por escrito."
      />
      <Navbar />
      <main className="pb-20 md:pb-0">
        <Breadcrumb items={[{ label: "Inicio" }]} />
        <HeroSection />
        <div className="hidden md:block">
          <TeamSection />
        </div>
        <WhyChooseSection />
        <ServicesSection />
        <TrustSection />
        <PricingSection />
        <div className="hidden md:block">
          <AveriasFrecuentesSection ids={["no-sube-ni-baja", "cinta-rota", "atascada-descolgada", "motor-no-funciona", "lamas-rotas", "recogedor-desprendido", "persiana-ruido", "persiana-madera", "mando-no-responde", "motorizar"]} />
        </div>
        <FAQSection
          title="Preguntas frecuentes sobre reparación de persianas en Málaga"
          questions={[
            {
              question: "¿Cuánto cuesta reparar una persiana?",
              answer: "Depende de la avería. Cambiar una cinta: entre 40€ y 75€. Sustituir un recogedor: entre 40€ y 65€. Cambio de motor tubular: entre 140€ y 280€ según modelo (Somfy o Nice). Sustituir lamas sueltas: desde 12€ por lama. Reparar una persiana atascada: desde 45€. Reparar una persiana de madera hinchada: desde 55€. Y una mosquitera nueva a medida, desde 60€. Son precios orientativos. El presupuesto exacto y cerrado te lo damos gratis tras revisar tu caso en persona, sin compromiso.",
            },
            {
              question: "¿Es mejor reparar o cambiar mi persiana?",
              answer: "En la mayoría de los casos, reparar sale más rentable. Una persiana con 10-15 años que solo necesita una cinta nueva o un recogedor tiene arreglo perfecto y mucho más barato que cambiarla entera. Solo recomendamos cambiar el sistema completo cuando la persiana tiene más de 25 años, las lamas están muy deterioradas, y el importe de la reparación supera el 60% del coste de una nueva. Te lo decimos con honestidad en el diagnóstico gratuito.",
            },
            {
              question: "¿Cuánto tardáis en venir?",
              answer: "Nuestro tiempo de respuesta estándar es de 24 a 48 horas. Para urgencias (persiana bloqueada que no cierra, local comercial sin cierre), podemos estar en el mismo día si nos llamas antes de las 12:00. No cobramos desplazamiento en ningún barrio de Málaga capital — los 16 barrios están dentro de nuestro radio de cobertura gratuito.",
            },
            {
              question: "¿Trabajáis con todas las marcas de persianas?",
              answer: "Sí. Somfy, Nice, Bubendorff, Gaviota, Simu, Alutech, Griesser, Vental, Gradhermetic, Simbac, Cherubini, Mitto, Maco, Ribind y todas las marcas del mercado. Disponemos de recambios originales para la mayoría de ellas. Si tu marca es menos habitual, buscamos la pieza y en 48 horas está solucionado. También trabajamos con sistemas antiguos de cinta de los años 70-90 donde encontrar el recambio adecuado requiere experiencia y un buen stock.",
            },
            {
              question: "¿El presupuesto es gratis?",
              answer: "Sí, totalmente gratis y sin compromiso. Nos desplazamos a tu domicilio, revisamos tu persiana o mosquitera, y te damos un precio cerrado por escrito antes de hacer nada. Sin coste de desplazamiento, sin letra pequeña, sin sorpresas. Tú decides si quieres que lo hagamos o no. Puedes pedir el presupuesto llamando al 951 12 07 70, por WhatsApp al 627 21 33 47, o mediante el formulario de esta web.",
            },
            {
              question: "¿Cobráis desplazamiento?",
              answer: "No. El desplazamiento es gratuito en los 16 barrios de Málaga capital. Cubrimos todo el término municipal: Centro, La Malagueta, El Palo, Pedregalejo, Teatinos, El Limonar, Churriana, Carretera de Cádiz, Cruz de Humilladero, Bailén-Miraflores, Ciudad Jardín, Puerto de la Torre, Campanillas, Huelin, Soliva y El Cónsul.",
            },
            {
              question: "¿Dais garantía?",
              answer: "Sí, 2 años de garantía por escrito en todas nuestras reparaciones e instalaciones. Cubre tanto las piezas sustituidas como la mano de obra. Si algo falla dentro de ese periodo, volvemos y lo arreglamos sin coste adicional para ti. Es una garantía real: si hay un problema, nos llamas y al día siguiente estamos en tu casa. Llevamos más de 10 años trabajando en Málaga y nuestra reputación se basa en eso.",
            },
          ]}
        />
        <div className="hidden md:block">
          <ComoTrabajamosSection />
        </div>
        {/* Guías de reparación */}
        <section className="hidden md:block py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">Guías de reparación de persianas</h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                Hemos preparado estas guías para ayudarte a entender qué le pasa a tu persiana. Si estás en Málaga, llámanos y lo reparamos nosotros.
              </p>
            </div>
            <div className="block sm:hidden">
              <div className="grid grid-cols-1 gap-2">
                {[
                  { slug: "como-cambiar-cinta-persiana", icon: "ri-scissors-cut-line", title: "Cómo cambiar la cinta", price: "desde 45 €" },
                  { slug: "persiana-no-sube-ni-baja", icon: "ri-arrow-up-down-line", title: "No sube ni baja", price: "desde 50 €" },
                  { slug: "persiana-atascada-descolgada", icon: "ri-error-warning-line", title: "Atascada o descolgada", price: "desde 50 €" },
                  { slug: "cambiar-motor-persiana", icon: "ri-settings-3-line", title: "Cambiar el motor", price: "desde 120 €" },
                ].map((g) => (
                  <Link key={g.slug} to={`/guias/${g.slug}`} className="flex items-center justify-between p-3.5 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-300/60 active:scale-[0.98] transition-all cursor-pointer">
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-600 flex-shrink-0">
                        <span className="w-4 h-4 flex items-center justify-center"><i className={g.icon}></i></span>
                      </div>
                      <span className="text-sm font-semibold text-foreground-800 truncate">{g.title}</span>
                    </div>
                    <span className="text-xs font-bold text-primary-600 whitespace-nowrap ml-2">{g.price}</span>
                  </Link>
                ))}
              </div>
              <Link to="/guias" className="mt-3 flex items-center justify-center gap-2 w-full py-3 bg-primary-500/10 hover:bg-primary-500/15 text-primary-700 font-semibold text-sm rounded-xl transition-all cursor-pointer">
                Ver las 7 guías de reparación
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-down-s-line"></i></span>
              </Link>
            </div>
            <div className="hidden sm:grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
              {[
                { slug: "como-cambiar-cinta-persiana", icon: "ri-scissors-cut-line", title: "Cómo cambiar la cinta", price: "desde 45 €" },
                { slug: "persiana-no-sube-ni-baja", icon: "ri-arrow-up-down-line", title: "No sube ni baja", price: "desde 50 €" },
                { slug: "persiana-atascada-descolgada", icon: "ri-error-warning-line", title: "Atascada o descolgada", price: "desde 50 €" },
                { slug: "cambiar-motor-persiana", icon: "ri-settings-3-line", title: "Cambiar el motor", price: "desde 120 €" },
                { slug: "cambiar-lamas-persiana", icon: "ri-stack-line", title: "Cambiar lamas rotas", price: "desde 70 €" },
                { slug: "reparar-recogedor-persiana", icon: "ri-uninstall-line", title: "Reparar el recogedor", price: "desde 40 €" },
                { slug: "como-cambiar-cuerda-persiana", icon: "ri-link-unlink", title: "Cambiar la cuerda", price: "desde 45 €" },
                { slug: "", icon: "ri-book-open-line", title: "Ver todas las guías", price: "" },
              ].map((g) => (
                g.slug ? (
                  <Link key={g.slug} to={`/guias/${g.slug}`} className="group p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-300/60 hover:-translate-y-0.5 transition-all cursor-pointer flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-600 flex-shrink-0">
                      <span className="w-4 h-4 flex items-center justify-center"><i className={g.icon}></i></span>
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-xs md:text-sm font-bold text-foreground-900 mb-1">{g.title}</h3>
                      <span className="text-xs text-primary-600 font-semibold">{g.price}</span>
                    </div>
                  </Link>
                ) : (
                  <Link key="all" to="/guias" className="group p-4 md:p-5 bg-gradient-to-br from-primary-500/10 to-accent-500/10 rounded-xl border border-primary-200/40 hover:border-primary-400/60 hover:-translate-y-0.5 transition-all cursor-pointer flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 flex-shrink-0">
                      <span className="w-4 h-4 flex items-center justify-center"><i className={g.icon}></i></span>
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-xs md:text-sm font-bold text-foreground-900 mb-1">{g.title}</h3>
                      <span className="text-xs text-primary-600 font-medium">+ información gratuita</span>
                    </div>
                  </Link>
                )
              ))}
            </div>
          </div>
        </section>
        <div className="hidden md:block">
          <NeighborhoodsSection />
        </div>
        <div className="hidden md:block">
          <VideoDiagnosisSection />
        </div>
        <div className="hidden md:block">
          <TestimonialsSection />
        </div>
        <QuoteFormSection />
      </main>
      <div className="hidden md:block">
        <TrustBannerSection />
      </div>
      <Footer />
      <MobileCTABar />
      <WhatsAppFloat />
    </div>
  );
}